import { LevelGranulometry } from '../../LevelGranulometry';

export const hasDrawnGeometry = (levelGranulometry: LevelGranulometry): boolean =>
  !!levelGranulometry?.geometry?.geometry;
